var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoDocumento(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#A3233B",
    fillRule: "nonzero",
    d: "M7.667 0C5.644 0 4 1.626 4 3.625v21.75C4 27.375 5.644 29 7.667 29h14.666C24.356 29 26 27.374 26 25.375V9.062h-7.333a1.821 1.821 0 0 1-1.834-1.812V0H7.667Zm11 0v7.25H26L18.667 0Zm-8.25 14.5h9.166c.505 0 .917.408.917.906a.914.914 0 0 1-.917.906h-9.166a.914.914 0 0 1-.917-.906c0-.498.412-.906.917-.906Zm0 3.625h9.166c.505 0 .917.408.917.906a.914.914 0 0 1-.917.907h-9.166a.914.914 0 0 1-.917-.907c0-.498.412-.906.917-.906Zm0 3.625h9.166c.505 0 .917.408.917.906a.914.914 0 0 1-.917.907h-9.166a.914.914 0 0 1-.917-.907c0-.498.412-.906.917-.906Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h30v30H0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoDocumento);
export default __webpack_public_path__ + "static/media/ico-documento.4b094330.svg";
export { ForwardRef as ReactComponent };